import React from "react";
import { Search } from "lucide-react";
import { DashboardAttentionEngagementStatus } from "../api/contracts";
import {
  engagementStatusOrder,
  engagementStatusPillToken,
  engagementStatusPresentation,
} from "../config/engagementStatus";
import { SingleSelectPillField } from "./SingleSelectPillField";

export type ClientSignalFilter = DashboardAttentionEngagementStatus | "";

export function initialClientSignalFilter(): ClientSignalFilter {
  if (typeof window === "undefined") return "";
  const requestedSignal = new URLSearchParams(window.location.search)
    .get("signal")
    ?.trim();
  return engagementStatusOrder.includes(
    requestedSignal as DashboardAttentionEngagementStatus,
  )
    ? (requestedSignal as DashboardAttentionEngagementStatus)
    : "";
}

const signalOptions = [
  { id: "all-signals", value: "", label: "All Signals" },
  ...engagementStatusOrder.map((status) => ({
    id: status,
    value: status,
    label: engagementStatusPresentation[status].label,
  })),
];

export function ClientListFilters({
  idPrefix,
  search,
  signal,
  afterSearch,
  onSearchChange,
  onSignalChange,
}: {
  idPrefix: string;
  search: string;
  signal: ClientSignalFilter;
  afterSearch?: React.ReactNode;
  onSearchChange: (value: string) => void;
  onSignalChange: (value: ClientSignalFilter) => void;
}) {
  return (
    <div
      className="cp-client-list-filters"
      role="group"
      aria-label="Client list filters"
    >
      <label className="cp-search-control">
        <Search aria-hidden="true" />
        <span className="cp-visually-hidden">Search clients</span>
        <input
          type="search"
          value={search}
          placeholder="Search clients"
          onChange={(event) => onSearchChange(event.currentTarget.value)}
        />
      </label>
      {afterSearch}
      <label className="cp-client-list-signal-filter">
        <span className="cp-visually-hidden">Filter by Signal</span>
        <SingleSelectPillField
          id={`${idPrefix}-signal-filter`}
          value={signal}
          options={signalOptions}
          ariaLabel="Filter by Signal"
          placeholder="All Signals"
          searchPlaceholder="Search Signals"
          emptyMessage="No Signals found"
          resolveColor={(option) =>
            option.value
              ? engagementStatusPillToken[
                  option.value as DashboardAttentionEngagementStatus
                ]
              : "neutral"
          }
          onChange={(value) => onSignalChange(value as ClientSignalFilter)}
        />
      </label>
    </div>
  );
}
